import { render } from "./RoleDetails.vue?vue&type=template&id=0d9cda7e&scoped=true&ts=true"
import script from "./RoleDetails.vue?vue&type=script&lang=ts"
export * from "./RoleDetails.vue?vue&type=script&lang=ts"

import "./RoleDetails.vue?vue&type=style&index=0&id=0d9cda7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9cda7e"]])

export default __exports__